<template>
  <v-form ref="filtersFrom" v-model="valid" class="pa-1">
    <v-row dense>
      <v-col xs="12" md="6">
        <services-filter
          v-model="localFilters[$options.filters.SERVICES]"
          :name="$options.filters.SERVICES"
          dense
        />
      </v-col>
      <v-col xs="12" md="6">
        <building-complex-filter
          v-model="localFilters[$options.filters.BUILDING_COMPLEXES]"
          :name="$options.filters.BUILDING_COMPLEXES"
          dense
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="6">
        <regions-filter
          v-model="localFilters[$options.filters.REGIONS]"
          :name="$options.filters.REGIONS"
          dense
        />
      </v-col>
      <v-col cols="12" md="6">
        <skills-filter
          v-model="localFilters[$options.filters.SKILLS]"
          :name="$options.filters.SKILLS"
          dense
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <employees-filter
          ref="employees"
          v-model="localFilters[$options.filters.EMPLOYEES]"
          :name="$options.filters.EMPLOYEES"
          :rules="rules[$options.filters.EMPLOYEES]"
          :filters="employeeFilters"
          dense
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" class="text-right">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn color="grey" depressed outlined @click="reset" v-on="on">
              <v-icon>mdi-filter-remove</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('BUTTON.CLEAR_FILTER') }}</span>
        </v-tooltip>
        <v-btn
          color="primary"
          class="ml-4"
          depressed
          :disabled="!valid"
          @click.prevent="find"
        >
          {{ $t('BUTTON.FIND') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { isEqual, omit } from 'lodash';
import { mapActions, mapState } from 'vuex';
import { clearObjectProperties } from '@/helpers/casting';
import query from '@/modules/_global/mixins/query';
import {
  notEmptyArray,
  maxLengthArray
} from '@/modules/_global/variables/rules';
import ServicesFilter from './filters/ServicesFilter';
import EmployeesFilter from './filters/EmployeesFilter';
import BuildingComplexFilter from './filters/BuildingComplexFilter';
import RegionsFilter from './filters/RegionsFilter';
import SkillsFilter from './filters/SkillsFilter';
import filters, { QUERY_STRUCTURE } from '../common/schedule-filters';

export default {
  name: 'ScheduleFilters',

  filters,

  components: {
    ServicesFilter,
    EmployeesFilter,
    BuildingComplexFilter,
    RegionsFilter,
    SkillsFilter
  },

  mixins: [query],

  data() {
    return {
      valid: false,
      localFilters: {},
      rules: {
        [filters.EMPLOYEES]: [notEmptyArray, maxLengthArray(10)]
      }
    };
  },

  computed: {
    ...mapState('planning', ['filters']),

    employeeFilters() {
      return omit(this.localFilters, [filters.EMPLOYEES]);
    }
  },

  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler: function(filters) {
        if (isEqual(filters, this.localFilters)) {
          return;
        }

        this.localFilters = {
          ...this.localFilters,
          ...filters
        };
      }
    }
  },

  mounted() {
    const filters = this.getQueryParams(QUERY_STRUCTURE);
    this.setScheduleFilters(filters);
  },

  methods: {
    ...mapActions('planning', ['setScheduleFilters']),

    reset() {
      clearObjectProperties(this.localFilters);
      this.$refs.filtersFrom.resetValidation();
      this.updateFilters();
    },

    find() {
      this.updateFilters();
      this.$emit('find', this.localFilters);
    },

    updateFilters() {
      this.setScheduleFilters(this.localFilters);
      this.setQuery(this.localFilters).catch(() => {});
    }
  }
};
</script>
